<template>
<list-software :is-train="true" />
</template>

<script>
import ListSoftware from './ListSoftware.vue';


export default {
  name: 'list-training',
  components: {
    ListSoftware
  },
};
</script>